import React, { useEffect, useState } from "react";
import { ChildContainer, Container } from "../../components/Container/Containers";
import IMAGES from "../../assets/images/images";
import styles from "./broadcast.module.css";
import {connect} from "react-redux";
import AddNewBoradcast from "./add/newbroadcast.container";
import BroadListViewer from "./list/broadcastList.container";
import { Banner } from "../../components/banner/Banners";

// const Banner=({myRights})=>{
//   return(
//     <div className={styles.bannerContainer}>
//             <img src={IMAGES.banner} className={`${styles.image}`} />
//             <div className={styles.textbanner}>
//               <div className={styles.text}>Broadcast Messages</div>
//                   <div className={styles.buttonContainer}>
//                     <div className={styles.buttondiv}>
//                       <AddNewBoradcast/>
//                     </div>
//                   </div>
//             </div>
//         </div>
//   )
// }
const Broadcast = (props) => {

    return (
    <Container>
      <Banner image={IMAGES.vfbanner} text={"Broadcast Messages"}>
        <div className={styles.buttonContainer}>
          <div className={styles.buttondiv}>
           <AddNewBoradcast/>
          </div>
        </div>
      </Banner>
      <ChildContainer>
        {
         <BroadListViewer/>
        }
      </ChildContainer>
    </Container>
  )
};

const mapStateToProps = (state) => { 
  return {
    myRights : state.myRights.myRights
  }
}

const mapDispatchToProps = (dispatch)=>{
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Broadcast);